module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "buttom_nav"
  }, [_c('div', {
    staticClass: "nav-list"
  }, [_c('router-link', {
    staticClass: "homePage navs",
    class: {
      buttom_select: _vm.select == 'btnOne'
    },
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changeOne()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.btnUrl
    }
  }), _vm._v("\n        首页\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "homePage navs",
    class: {
      buttom_select: _vm.select == 'btnTwo'
    },
    attrs: {
      "to": "/project"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changeTwo()
      }
    }
  }, [_c('icon', {
    staticClass: "select_icon",
    attrs: {
      "name": "inbox"
    }
  }), _vm._v("\n        项目\n      ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "homePage navs",
    class: {
      buttom_select: _vm.select == 'btnThree'
    },
    attrs: {
      "to": "/createProject"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changeThree()
      }
    }
  }, [_c('icon', {
    staticClass: "select_icon",
    attrs: {
      "name": "plus-square-o"
    }
  }), _vm._v("\n        发布\n      ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "homePage navs",
    class: {
      buttom_select: _vm.select == 'btnFour'
    },
    attrs: {
      "to": "/custom"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changeFour()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.urlpeo
    }
  }), _vm._v("\n        客服\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "homePage navs",
    class: {
      buttom_select: _vm.select == 'btnFive'
    },
    attrs: {
      "to": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changeFive()
      }
    }
  }, [_c('icon', {
    staticClass: "select_icon",
    attrs: {
      "name": "user-circle"
    }
  }), _vm._v("\n        我的\n      ")], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bb6756c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bottom.vue
// module id = 1286
// module chunks = 1